import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Storage } from '@ionic/storage';

import { timeout } from 'rxjs/operators';

import { UsuarioProvider } from '../providers/usuario.provider';
import { BaseService } from './base.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class BrowserBaseService extends BaseService {

    private TIMEOUT = 60;

    constructor(
        public router: Router,
        public http: HttpClient,
        public storage: Storage,
        public usuarioProvider: UsuarioProvider
    ) {

        super();
    }

    async montarGet(url: string, headers: any): Promise<any> {
        try {
            let response: any = await this.http.get(url, this.montarHttpHeader(headers)).pipe(timeout(this.TIMEOUT * 1000)).toPromise();
            if (response.error) {
                response = {
                    error: {
                        message: response.error.events[0].message
                    }
                };
                throw response;
            } else if (response.data && response.data.records) {
                response = response.data.records;
            } else {
                response = response;
            }


            return {
                status: response.status,
                data: JSON.stringify(response)
            };
        } catch (error) {
            if (error.name !== undefined && error.name !== null && error.name === 'TimeoutError') {
                error.error = 'timed out';
            } else {
                error.error = JSON.stringify(error.error);
            }

            throw error;
        }
    }

    async montarPost(url: string, body: any, headers: any): Promise<any> {

        try {
            const data = await this.http.post(url, body, this.montarHttpHeader(headers)).pipe(timeout(this.TIMEOUT * 1000)).toPromise();

            return {
                status: 200,
                data: data ? JSON.stringify(data) : null
            };
        } catch (error) {
            if (error.name !== undefined && error.name !== null && error.name === 'TimeoutError') {
                error.error = 'timed out';
            } else {
                error.error = JSON.stringify(error.error);
            }

            throw error;
        }
    }

    async montarPut(url: string, body: any, headers: any): Promise<any> {
        try {
            const data = await this.http.put(url, body, this.montarHttpHeader(headers)).pipe(timeout(this.TIMEOUT * 1000)).toPromise();

            return {
                status: 200,
                data: data ? JSON.stringify(data) : null
            };
        } catch (error) {
            if (error.name !== undefined && error.name !== null && error.name === 'TimeoutError') {
                error.error = 'timed out';
            } else {
                error.error = JSON.stringify(error.error);
            }

            throw error;
        }
    }

    async montarDelete(url: string, headers: any): Promise<any> {
        try {
            const data = await this.http.delete(url, this.montarHttpHeader(headers)).pipe(timeout(this.TIMEOUT * 1000)).toPromise();

            return {
                status: 200,
                data: data ? JSON.stringify(data) : null
            };
        } catch (error) {
            if (error.name !== undefined && error.name !== null && error.name === 'TimeoutError') {
                error.error = 'timed out';
            } else {
                error.error = JSON.stringify(error.error);
            }
            throw error;
        }
    }

    private montarHttpHeader(headers: any) {

        let httpHeaders = new HttpHeaders();

        for (const x in headers) {
            if (headers.hasOwnProperty(x)) {
                httpHeaders = httpHeaders.set(x, headers[x]);
            }
        }

        const httpOptions = {
            headers: httpHeaders
        };

        return httpOptions;
    }

}
